<template>
  <div class="panel-in-tab">
    <div style="height: 20px"></div>
    <el-table :data="expectedSalesDaysList" ref="tableRef" border height="40%" :span-method="objectSpanMethod" v-loading="loading">
      <el-table-column label="影响因子" prop="impactFactors" min-width="120px" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="权重占比" prop="weight" show-overflow-tooltip></el-table-column>
      <el-table-column label="单位" prop="unitDesc" min-width="50px"></el-table-column>
      <el-table-column label="下限（含）" prop="limitLower" min-width="120px"></el-table-column>
      <el-table-column label="上限" prop="limitUpper" min-width="120px"></el-table-column>
      <el-table-column label="得分" prop="score" min-width="60px"></el-table-column>
      <el-table-column label="备注" prop="ruleDesc" min-width="250px" show-overflow-tooltip></el-table-column>
      <el-table-column label="更新人" prop="updatedBy" min-width="80px"></el-table-column>
      <el-table-column label="更新时间" prop="updatedDate" min-width="160px"></el-table-column>
      <el-table-column label="操作" width="150px" align="center">
        <template slot-scope="scoped">
          <el-link type="primary" :underline="false" @click="edit(expectedSalesDaysList, 2)">修改</el-link>
          <el-link type="primary" :underline="false" @click="history(scoped.row,'62')">历史记录</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 20px"></div>
    <el-table :data="marketTimeList" ref="tableRef" border height="40% " :span-method="objectSpanMethod2" v-loading="loading">
      <el-table-column label="影响因子" prop="impactFactors" min-width="120px" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="权重占比" prop="weight" show-overflow-tooltip></el-table-column>
      <el-table-column label="单位" prop="unitDesc" min-width="50px"></el-table-column>
      <el-table-column label="下限（含）" prop="limitLower" min-width="120px"></el-table-column>
      <el-table-column label="上限" prop="limitUpper" min-width="120px"></el-table-column>
      <el-table-column label="得分" prop="score" min-width="60px"></el-table-column>
      <el-table-column label="备注" prop="ruleDesc" min-width="250px" show-overflow-tooltip></el-table-column>
      <el-table-column label="更新人" prop="updatedBy" min-width="80px"></el-table-column>
      <el-table-column label="更新时间" prop="updatedDate" min-width="160px"></el-table-column>
      <el-table-column label="操作" width="150px" align="center">
        <template slot-scope="scoped">
          <el-link type="primary" :underline="false" @click="edit(marketTimeList, 3)">修改</el-link>
          <el-link type="primary" :underline="false" @click="history(scoped.row,'63')">历史记录</el-link>
        </template>
      </el-table-column>
    </el-table>
    <edit-dialog :visible.sync="editVisible" v-if="editVisible" :rowData="rowData" :dataType="dataType" @success="onSearch" />
    <history-dialog :visible.sync="historyVisible" v-if="historyVisible" :dataType="dataType" :rowData="rowData" />
  </div>
</template>

<script>
import editDialog from "./components/edit";
import historyDialog from "./components/history";
import tableMixin from "@/utils/tableMixin";
export default {
  mixins: [tableMixin],
  components: { editDialog, historyDialog },
  data() {
    return {
      form: {},
      tableHeight: 0,
      tableData: [],
      editVisible: false,
      historyVisible: false,
      expectedSalesDaysList: [],
      marketTimeList: [],
      rowData: {},
      loading: false,
      dataType: '',
      spanArr: [],
      spanArr2: [],
      spanIndex: 0,
      spanIndex2: 0,
    };
  },
  computed: {},
  mounted() {
    this.onSearch();
  },
  methods: {
    onSearch() {
      this.init();
    },
    async init() {
      this.loading = true;
      this.$q.newProduct
        .configImpactFactors()
        .then((res) => {
          let { expectedSalesDaysList, marketTimeList } = res.data || {}
          this.expectedSalesDaysList = expectedSalesDaysList || []
          this.marketTimeList = marketTimeList || []
          this.computeSpanData(expectedSalesDaysList)
          this.computeSpanData2(marketTimeList)
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },
    // 重置
    reset() {
      this.form = {};
      this.init();
    },
    // 修改 弹出dialog
    edit(data, dataType) {
      this.dataType = dataType
      this.rowData = JSON.parse(JSON.stringify(data));
      this.editVisible = true;
    },
    history(row, dataType) {
      this.rowData = row;
      this.dataType = dataType
      this.historyVisible = true;
    },
    // 遍历表格数据，计算合并行数据
    computeSpanData(list) {
      this.spanArr = [];
      list.forEach((item, index) => {
        this.recordSpanData(index, list);
      });
    },
    // 遍历表格数据，计算合并行数据
    computeSpanData2(list) {
      this.spanArr2 = [];
      list.forEach((item, index) => {
        this.recordSpanData2(index, list);
      });
    },
    // 计算每一行的合并行数据
    recordSpanData2(index, data) {
      if (index === 0) {
        this.spanArr2.push(1)
        this.spanIndex2 = 0
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[index].impactFactors === data[index - 1].impactFactors) {
          this.spanArr2[this.spanIndex2] += 1
          this.spanArr2.push(0)
        } else {
          this.spanArr2.push(1)
          this.spanIndex2 = index
        }
      }
    },
    // 计算每一行的合并行数据
    recordSpanData(index, data) {
      if (index === 0) {
        this.spanArr.push(1)
        this.spanIndex = 0
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[index].impactFactors === data[index - 1].impactFactors) {
          this.spanArr[this.spanIndex] += 1
          this.spanArr.push(0)
        } else {
          this.spanArr.push(1)
          this.spanIndex = index
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex < 3 || columnIndex > 5) {
        return {
          rowspan: this.spanArr[rowIndex],
          colspan: 1
        };
      }
    },
    objectSpanMethod2({ rowIndex, columnIndex }) {
      if (columnIndex < 3 || columnIndex > 5) {
        return {
          rowspan: this.spanArr2[rowIndex],
          colspan: 1
        };
      }
    },
  },
};
</script>

<style lang="stylus" scoped>

.panel-in-tab {
  height : calc(100vh - 125px)
}
.panel-in-tab
  >>> .search-outer>div
    padding 0

 >>> .content-panel {
   height: 100%
 }
</style>
<style lang="css">
.el-tooltip__popper {
  max-width: 40%;
}
</style>
